module.exports = __webpack_public_path__ + "static/media/СЛ вечер.70b520e4.jpg";